<template>
  <div>
    <div class="columns is-centered mt-5 px-5">
      <div class="column is-6 container">
        <div class="image-container">
          <b-image class="my-5" :src="img" style="width: 80%" />
        </div>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-12">
        <b-message class="is-info has-text-left">
          El ingreso especial corresponde a los solicitantes, previamente autorizados, para ingresar con un correo Google distinto al correo usach.
        </b-message>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: "/opc_2_color.png",
    };
  },
}

</script>


<style scoped>

.button {
  border-radius: 10px;
}
.box {
  border-radius: 20px;
}
.input {
  border-radius: 20px;
}
.image-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

</style>